import { render, staticRenderFns } from "./VideoEditTest.vue?vue&type=template&id=22cbfd79&scoped=true&"
import script from "./VideoEditTest.vue?vue&type=script&lang=js&"
export * from "./VideoEditTest.vue?vue&type=script&lang=js&"
import style0 from "./VideoEditTest.vue?vue&type=style&index=0&id=22cbfd79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cbfd79",
  null
  
)

export default component.exports